import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { PenLine } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';
import SignatureCanvas from '../SignatureCanvas';

export const SignerCharte = ({ signatureProfil, onSignee }) => {
  const [lu, setLu] = useState(false);
  const [envoi, setEnvoi] = useState(false);

  const signer = async (signature) => {
    setEnvoi(true);
    try {
      await axios.post('/charte-formateurs/signer', { signature });
      toast.success('Charte signée, merci !');
      onSignee();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de la signature');
      setEnvoi(false);
    }
  };

  return (
    <section className="rounded-2xl border-2 border-[#8DC63F]/50 bg-white p-6 sm:p-10 shadow-sm" data-testid="ma-charte-signer">
      <div className="flex items-center gap-3">
        <div className="rounded-xl bg-[#8DC63F]/15 p-2.5"><PenLine className="h-5 w-5 text-[#6FA22E]" /></div>
        <h2 className="text-base md:text-lg font-semibold text-[#0F172A]">Signer la charte</h2>
      </div>
      <label className="mt-6 flex cursor-pointer items-start gap-3 text-sm sm:text-base text-slate-700" htmlFor="ma-charte-case">
        <Checkbox id="ma-charte-case" checked={lu} onCheckedChange={(v) => setLu(!!v)} className="mt-0.5" data-testid="ma-charte-case-lu" />
        J'ai lu la charte des formateurs FISL et je m'engage à en respecter l'ensemble des dispositions.
      </label>
      {lu && (
        <div className="mt-8 animate-in fade-in slide-in-from-top-2 duration-300" data-testid="ma-charte-zone-signature">
          <SignatureCanvas onSave={signer} loading={envoi} buttonText="Signer la charte" existingSignature={signatureProfil} />
        </div>
      )}
    </section>
  );
};
